import {
    ETableColCondition,
    ETableColDataType,
    ETableColFilterType,
    ETableColFreeze,
    ETableColType,
    TableColDef
} from './table-col-def';

export class TableColDefCache {
    public iID?: number;
    public index?: number;
    public tableColDef?: TableColDef;

    public conditionEval!: boolean[];
    public freezeDirection!: string;
    public wrapperClassList?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public booleanLabelStyleCache?: (Record<string, any> | undefined)[];

    // ===============================================================
    // ===============================================================

    public _init(iID: number, tableColDefs: TableColDef[], tableColDef: TableColDef) {
        this.initTableColDef(tableColDef);

        this.iID = iID;
        this.index = tableColDefs.indexOf(tableColDef);
        this.tableColDef = tableColDef;

        if (tableColDef.condition) {
            this.conditionEval = [
                tableColDef.condition == ETableColCondition.NON_ROOT_ONLY,
                tableColDef.condition == ETableColCondition.ROOT_ONLY
            ];
        } else {
            this.conditionEval = [true, true];
        }

        this.freezeDirection = tableColDef.freeze === ETableColFreeze.RIGHT ? 'left' : 'right';

        if (tableColDef.fnOnCellClick) {
            this.wrapperClassList = 'pointer text-decoration-underline';
        } else {
            this.wrapperClassList = '';
        }

        if (tableColDef.dataType === ETableColDataType.BOOLEAN_LABEL) {
            this.booleanLabelStyleCache = [
                tableColDef.tags?.find((opt) => !opt.value)?.style ?? undefined,
                tableColDef.tags?.find((opt) => !!opt.value)?.style ?? undefined
            ];
        }
    }

    private initTableColDef(tableColDef: TableColDef) {
        if (tableColDef.type === undefined) tableColDef.type = ETableColType.DATA;
        if (tableColDef.dataType === undefined) tableColDef.dataType = ETableColDataType.TEXT;
        if (tableColDef.searcheable === undefined) tableColDef.searcheable = true;
        if (tableColDef.sortable === undefined) tableColDef.sortable = true;
        if (tableColDef.filterable === undefined) tableColDef.filterable = true;
        if (tableColDef.filterType === undefined) tableColDef.filterType = ETableColFilterType.TEXT;
    }
}
